module.exports = __webpack_public_path__ + "img/59.2741e41e.jpg";